import streamwest from "./streamwest.png"
import blue from "./BlueStreamWest.png"
import chatIcon from "./chatIcon.png"
import crossIcon from "./crossIcon.png"
import wmlogo from "./wmlogo.png"
import testThumbnail from "./testThumbnail.png"
import testThumbnail2 from "./testThumbnail2.png"
import texasThumbnail from "./texasThumbnail.png"

export const assets = {
    streamwest,
    blue,
    chatIcon,
    crossIcon,
    wmlogo,
    testThumbnail,
    testThumbnail2,
    texasThumbnail,

}
